export type CurrencyCodeType = 'GBP' | 'EUR' | 'USD';

export const getCurrencyName = (currencyCode?: CurrencyCodeType): string => {
  let currencyName = 'Sterling';

  switch (currencyCode) {
    case 'GBP':
      currencyName = 'Sterling';
      break;
    case 'EUR':
      currencyName = 'Euro';
      break;
    case 'USD':
      currencyName = 'Dollar';
      break;
    default:
      currencyName = 'Sterling';
  }

  return currencyName;
};
